require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./financing-and-scholarships.json") })
        }
      }, "path---financing-and-scholarships");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---financing-and-scholarships!./.cache/json/financing-and-scholarships.json
// module id = 1180
// module chunks = 231608221292675